module.exports = __webpack_public_path__ + "img/icon_sm_xsrb.4a95fa11.png";